export const scriptAdjustFontSize = (widthContainer: number) => `
<script>
  function adjustFontSizes() {
      const container = document.querySelector('[data-id="ROOT"]');
      const containerWidth = container.offsetWidth;
      const elements = container.querySelectorAll('[data-type="TextLayer"] p');

      elements.forEach(element => {
          if (!element.dataset.originalFontSize) {
              element.dataset.originalFontSize = window.getComputedStyle(element).fontSize;
          }

          const originalFontSize = parseFloat(element.dataset.originalFontSize);
          const originalContainerWidth = ${widthContainer};

          const newFontSize = (containerWidth / originalContainerWidth) * originalFontSize;
          element.style.fontSize = newFontSize+"px";
      });
  }

  window.addEventListener("load", adjustFontSizes);
  window.addEventListener("resize", adjustFontSizes);
</script>
`

export const scriptChangeSizeFrame = `
<script>
  (() => {
    const containers = document.querySelectorAll('.frame-layer-container');

    const updateScale = (container) => {
      const frameSizeWidth = parseFloat(container.getAttribute('data-frame-width'));
      const transformDiv = container.querySelector('.frame-layer-transform');
      const calculatedScale = container.clientWidth / frameSizeWidth;
      transformDiv.style.transform = \`scale(\${calculatedScale})\`;
    };

    containers.forEach((container) => {
      updateScale(container);

      const resizeObserver = new ResizeObserver(() => {
        updateScale(container);
      });
      resizeObserver.observe(container);
    });
  })();
</script>
`;


export const scriptClickthroughRedirect = `
  function resolveClickUrl(id) {
    const url = clickthrough[id];
    if (!url) return null;

    if (url.startsWith("{") && url.endsWith("}") && url.includes(":")) {
      return url.slice(url.indexOf(":") + 1, -1);
    }

    return url;
  }

  function redirectToURL(id, event) {
    if (id !== "ROOT") {
      event.stopPropagation();
    }
    const url = resolveClickUrl(id);
    if (url) {
      window.location.href = url;
    } else {
      console.warn("URL not found for id: " + id);
    }
  }

  function redirectClickTag(id, event) {
    if (id !== "ROOT") {
      event.stopPropagation();
    }
    const url = resolveClickUrl(id);
    if (url) {
      window.open(url, "_blank");
    } else {
      console.warn("URL not found for id: " + id);
    }
  }
`;

export const scriptPollClicks = `
  <script>
    let cl = false;

    document.addEventListener('click', function (event) {

      if (cl) {
        return;
      }

      cl = true;

      const x = event.clientX;
      const y = event.clientY;
      const width = window.innerWidth;
      const height = window.innerHeight;

      const body = {
        campaignId: "{campaignid}",
        bannerId: "{bannerid}",
        height,
        width,
        udid: "{udid}",
        x,
        y,
        adUnitId: "{adUnitId}",
        assetId: "{asset}",
        language: "{language}"
      };

      fetch("https://polls.service.wortise.com/clicks", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
    });
  </script>
`;
